import { claimTypeValues } from '@/common/constants'

export const isFormValid = (type, description, images) => {
  if (!description) return false
  if (type === claimTypeValues.deliveredDamagedOrMissingItems && images.length === 0) return false
  return true
}
